export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collab.vue?vue&type=template&id=7ccfc7a0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/collab.vue?vue&type=template&id=7ccfc7a0&
// module id = 1636
// module chunks = 0